import {
  Box,
  CardContent,
  Container,
  CssBaseline,
  FormControl,
  FormLabel,
  Grid,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Typography,
  Card,
  TextField
} from 'src/shared/components/index';
import Group from 'src/assets/images/group.svg';
import BackgroundImage from 'src/assets/images/pageBg.png';
import Logo from 'src/assets/images/bookingDliteLogo.png';
import { useTranslation } from 'react-i18next';
import { forgetPassowrdApiCall } from './apis/login';
import * as ROUTES from '../../shared/constants/routes';
import { AUTH_CONFIG } from '../../shared/constants/constants';

const ForgotPassword = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [loginType, setLoginType] = useState<string>('');
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isForgetPassword, setIsForgetPassword] = useState<boolean>(true);

  useEffect(() => {
    if (window.location.pathname === ROUTES.ADMIN_FORGET_PASSWORD) {
      setLoginType(AUTH_CONFIG.LOGIN_TYPE_ADMIN);
    } else {
      setLoginType(AUTH_CONFIG.LOGIN_TYPE_USER);
    }
  }, []);

  const onSubmit = async () => {
    if (email.trim().length === 0) {
      setErrorMessage('Enter valid email');
    } else {
      const requestData = {
        email: email,
        loginType: loginType
      };
      try {
        const response = await forgetPassowrdApiCall(requestData);
        if (response) {
          setIsForgetPassword(false);
        }
      } catch (error) {
        setErrorMessage(error.response.data.message[0]);
      }
    }
  };

  const redirectToLogin = async () => {
    if (window.location.pathname === ROUTES.ADMIN_FORGET_PASSWORD) {
      navigate(ROUTES.ADMIN_LOGIN);
    } else {
      navigate(ROUTES.LOGIN);
    }
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        onSubmit();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [email]);

  const { t } = useTranslation('authentication');

  return (
    <div style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <Container className="loginWrapper h-100 flex-basic-center">
        <Container className="containerCenter" maxWidth="md">
          <Card
            className="card-size"
            sx={{
              bgcolor: theme.colors.alpha.white
            }}
          >
            <Grid container spacing={2}>
              <Grid
                className="flex-basic-center grid-size"
                item
                xs={12}
                md={6}
                sm={6}
                lg={6}
              >
                <Box>
                  <img src={Group} alt="Person" className="image-size" />
                </Box>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                style={{ display: isForgetPassword ? 'line-through' : 'none' }}
              >
                <CardContent sx={{ p: 5 }}>
                  <CssBaseline />

                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography
                      variant="h2"
                      color={theme.colors.primary.main}
                      sx={{ mb: 1 }}
                      align="left"
                      title="welcome_heading"
                    >
                      {t('forgot-password')}
                    </Typography>

                    <Typography
                      variant="h5"
                      color={theme.colors.primary}
                      sx={{ mb: 7 }}
                      align="left"
                      title="sub_heading"
                    >
                      {t('enter-email-id')}
                    </Typography>
                  </Box>

                  {errorMessage && (
                    <Box>
                      <Typography variant="h4" color="text" fontWeight="normal">
                        <FormControl error={true} variant="standard">
                          <FormLabel id="demo-error-radios">
                            {errorMessage}
                          </FormLabel>
                        </FormControl>
                      </Typography>
                    </Box>
                  )}

                  <Box sx={{ mb: 2 }}>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </Box>

                  <Button
                    type="submit"
                    onClick={onSubmit}
                    fullWidth
                    form="loginForm"
                    variant="contained"
                    btnText={t('Send')}
                    sx={{
                      mb: 1,
                      '&:disabled': {
                        backgroundColor: theme.colors.primary.main,
                        color: 'white !important'
                      }
                    }}
                  />
                </CardContent>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <CardContent sx={{ p: 5 }}>
                  <CssBaseline />

                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography
                      variant="h2"
                      color={theme.colors.primary.main}
                      sx={{ mb: 1 }}
                      align="left"
                      title="heading"
                    >
                      {t('check-your-mail')}
                    </Typography>

                    <Typography
                      variant="h5"
                      color={theme.colors.primary}
                      sx={{ mt: 8 }}
                      align="left"
                      title="subHeading"
                    >
                      {t('Email has been sent to your email ' + email, {
                        ns: 'checkEmail'
                      })}
                    </Typography>
                  </Box>

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    onClick={() => redirectToLogin()}
                    btnText={t('back-to-login')}
                    sx={{ bgcolor: theme.colors.primary, mt: 12 }}
                  ></Button>
                </CardContent>
              </Grid>
            </Grid>
          </Card>
        </Container>
      </Container>
    </div>
  );
};

export default ForgotPassword;
